import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { User } from '../domain/users/user.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UserPasswordUpdate } from '../domain/users/user-password-update.model';
import { HttpUtils } from '../utils/http-utils';

@Injectable()
export class AdStatsTipaltiService {

  constructor(private http: HttpClient) {
  }

  public getTipaltiSetupUrl(pubId: string): Observable<any> {
    return this.http.get(`${environment.serviceUrl}/ad-stats/tipaltictrl/setup`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams({
        pub: pubId
      })
    });
  }
  public getTipaltiPaymentsUrl(pubId: string): Observable<any> {
    return this.http.get(`${environment.serviceUrl}/ad-stats/tipaltictrl/payments`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams({
        pub: pubId
      })
    });
  }
}
